import { Box, Stack, Typography } from '@mui/material'
import { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RightSlider } from '../../../../components/sliders'
import { AppDispatch } from '../../../../store'
import { TechGrantsActions, TechGrantSelectors } from '../../../../store/technology'
import { ProjectGrant } from '../../../Projects/subComponents/Project/sharedComponents/ProjectGrant'
import { ListGridToggleButtons } from './ListGridToggleButtons'
import { MatchesGrid } from './MatchesGrid'
import { MatchesTable } from './MatchesTable'

export const TotalMatches: FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const [showGrantDetail, setShowGrantDetail] = useState(false)
  const [grantView, setGrantView] = useState<'list' | 'grid'>('list')
  const [selectedGrant, setSelectedGrant] = useState({ projectId: '', refId: '' })

  const paging = useSelector(TechGrantSelectors.getPaging)

  const { limit, skip } = paging

  const fetchGrants = useCallback(() => {
    const options = {
      params: {
        $limit: limit,
        $skip: skip,
      },
    }

    dispatch(TechGrantsActions.fetchCurrentUserMatchedGrantsAsync({ options }))
  }, [dispatch, limit, skip])

  useEffect(() => {
    fetchGrants()
  }, [fetchGrants])

  const handleGrantDetailSlideOut = (projectId: string, refId: string) => {
    setSelectedGrant({ projectId, refId })
    setShowGrantDetail(true)
  }

  const handleSliderClose = () => {
    fetchGrants()
    setShowGrantDetail(false)
  }

  return (
    <Box width="100%">
      <RightSlider
        open={showGrantDetail}
        setOpen={setShowGrantDetail}
        closeButtonAction={handleSliderClose}
      >
        <ProjectGrant projectId={selectedGrant.projectId} refId={selectedGrant.refId} />
      </RightSlider>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="secondary" fontSize="1rem" fontWeight={600}>
          Matches
        </Typography>

        <ListGridToggleButtons activeView={grantView} setActiveView={setGrantView} />
      </Stack>

      {grantView === 'list' && (
        <MatchesTable
          fetchGrants={fetchGrants}
          handleGrantDetailSlideOut={handleGrantDetailSlideOut}
        />
      )}
      {grantView === 'grid' && (
        <MatchesGrid
          fetchGrants={fetchGrants}
          handleGrantDetailSlideOut={handleGrantDetailSlideOut}
        />
      )}
    </Box>
  )
}
